export default __webpack_public_path__ + "static/media/V120_SOV.90cd718e.pdf";